import { Contract, } from 'ethers';
import {
  default as getContractData,
} from './getUlsStakingContractData';



export default function getUlsStakingContract(ethersProviderSigner = null) {
  const { address, abi, /*chainId,*/ } = getContractData();
  const contract = new Contract(address, abi, ethersProviderSigner);
  return contract;
}
